/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteFacilityRegion200ResponseData
 */
export interface DeleteFacilityRegion200ResponseData {
    /**
     * 
     */
    id: string;
}

/**
 * Check if a given object implements the DeleteFacilityRegion200ResponseData interface.
 */
export function instanceOfDeleteFacilityRegion200ResponseData(value: object): value is DeleteFacilityRegion200ResponseData {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DeleteFacilityRegion200ResponseDataFromJSON(json: any): DeleteFacilityRegion200ResponseData {
    return DeleteFacilityRegion200ResponseDataFromJSONTyped(json, false);
}

export function DeleteFacilityRegion200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityRegion200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function DeleteFacilityRegion200ResponseDataToJSON(json: any): DeleteFacilityRegion200ResponseData {
    return DeleteFacilityRegion200ResponseDataToJSONTyped(json, false);
}

export function DeleteFacilityRegion200ResponseDataToJSONTyped(value?: DeleteFacilityRegion200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

